import HTMLElement from '../html-element/HTMLElement.js';
/**
 * HTMLPreElement
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLPreElement
 */
export default class HTMLPreElement extends HTMLElement {}
